import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { Container } from '@atlassian/jira-common-directory-v2/src/components/text-cell/styled';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { borderRadius, gridSize } from '@atlassian/jira-common-styles/src';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import type { Props } from './types';

const Name = (props: Props) => {
	const { name, avatarUrl } = props;
	return (
		<StyledContainer>
			<Avatar
				src={avatarUrl}
				srcSet={`${avatarUrl}?size=small, ${avatarUrl}?size=large 2x`}
				alt=""
			/>
			<Label>{name}</Label>
		</StyledContainer>
	);
};

export default Name;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Label = styled2.span({
	marginLeft: token('space.400', '32px'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

const avatarSize = gridSize * 3;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContainerOld = styled(Container)({
	alignItems: 'center',
	paddingTop: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const StyledContainerNew = styled2(Container)({
	alignItems: 'center',
	display: 'flex',
	paddingTop: token('space.100'),
});

const StyledContainer = componentWithFF(
	'hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3',
	StyledContainerNew,
	StyledContainerOld,
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarOld = styled.img<any>({
	flexShrink: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${avatarSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${avatarSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginRight: `${avatarSize * -1}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius}px`,
	display: 'inline-block',
	verticalAlign: 'middle',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const AvatarNew = styled2.img({
	flexShrink: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 3}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 3}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginRight: `${gridSize * 3 * -1}px`,

	borderRadius: '3px',
	display: 'inline-block',
	verticalAlign: 'middle',
});

const Avatar = componentWithFF(
	'hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3',
	AvatarNew,
	AvatarOld,
);
